import React, { ReactNode } from "react";

import classNames from "classnames";
import { useIntl } from "gatsby-plugin-react-intl";

import { ReactComponent as IconArticle18 } from "../../icons/icon/18/a-icon-article-18.svg";
import IconText from "../iconText/iconText";
import NavigationLink from "../navigationLink/navigationLink";

import "./learnArticleEmbed.scss";

interface LearnArticleEmbedProps {
  headline: string;
  image: ReactNode;
  href: string;
  border?: boolean;
}

const LearnArticleEmbed: React.FC<LearnArticleEmbedProps> = ({
  headline,
  image,
  href,
  border = false,
}) => {
  const intl = useIntl();

  return (
    <NavigationLink
      href={href}
      className={classNames("learn-article-embed", "no-style", { "learn-article-embed--border": border })}
    >
      <div className="learn-article-embed__image-container">
        <div className="learn-article-embed__image">{image}</div>
      </div>
      <div className="learn-article-embed__content">
        <IconText
          icon={<IconArticle18 />}
          variant="learn-area"
          text={intl.formatMessage({ id: "learn_article_embed.article" })}
        />
        <div className="learn-article-embed__headline">{headline}</div>
      </div>
    </NavigationLink>
  );
};

export default LearnArticleEmbed;
